import { moduleFactory } from "@/factories/module";
import {
  _writeLocalStoragePendingRedirectPath,
  _clearLocalStoragePendingRedirectPath,
  _readLocalStoragePendingRedirectPath,
} from "@/modules/local-storage/redirect";
import {
  _readLocalStorageSidebarState,
  _writeLocalStorageSidebarState,
} from "@/modules/local-storage/sidebar";
import {
  _readLocalStorageThemePreference,
  _writeLocalStorageThemePreference,
  _clearLocalStorageThemePreference,
} from "@/modules/local-storage/theme";

export const localStorageModule = moduleFactory.create({
  writePendingRedirectPath: _writeLocalStoragePendingRedirectPath,
  clearPendingRedirectPath: _clearLocalStoragePendingRedirectPath,
  readPendingRedirectPath: _readLocalStoragePendingRedirectPath,
  readSidebarState: _readLocalStorageSidebarState,
  writeSidebarState: _writeLocalStorageSidebarState,
  readThemePreference: _readLocalStorageThemePreference,
  writeThemePreference: _writeLocalStorageThemePreference,
  clearThemePreference: _clearLocalStorageThemePreference,
});
